export default __webpack_public_path__ + "static/media/logo_afts.87b7ed22.png";